import axios from "axios";
import HttpHeader from "../../../header";

const httpHeader = HttpHeader.getInstance();

const instance = axios.create({
  baseURL: process.env.REACT_APP_NOTIFICATION_API_URL || "https://dev-notification-api.coastr.com:5005",
  headers: {
    "Content-Type": "application/json"
  }
});

instance.interceptors.request.use(async (config) => {
  config.headers = {
    ...config.headers,
    ...httpHeader.headers
  };
  return config;
});

export default {
  getNotifications: () => instance.get("/notifications"),
  getCount: (status: string) => instance.get("/notifications/count", { params: { status } }),
  updateReadStatus: (variables: { notificationId: string; status: string }) => instance.post("/notification", variables)
};
